import type {
  IFormGenContext,
  IFormGenSchema,
  TFormGenUiSchema,
  TJSONSchema,
} from "@artifact-management/json-dynamic-form";
import { Grid } from "@mui/material";
import type { Control, FieldValues, UseFormSetValue, UseFormSubscribe } from "react-hook-form";
import { FormGenComponent } from "./Components";
import { useFormGenElement } from "./logics";

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export interface IFormGenElementProps<Schema extends TJSONSchema, T extends FieldValues = any> {
  control: Control<T>;
  setValue: UseFormSetValue<T>;
  subscribe: UseFormSubscribe<T>;
  schema: IFormGenSchema<Schema>;
  parsedJsonSchema: TJSONSchema;
  uiSchemaIndex: number;
  uiSchemaElement: TFormGenUiSchema<Schema>;
  context?: IFormGenContext;
}

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const FormGenElement = <Schema extends TJSONSchema, T extends FieldValues = any>({
  control,
  setValue,
  subscribe,
  schema,
  parsedJsonSchema,
  uiSchemaIndex,
  uiSchemaElement,
  context,
}: IFormGenElementProps<Schema, T>) => {
  const currentElementState = useFormGenElement(schema, uiSchemaElement, subscribe);

  if (currentElementState.hidden) {
    return null;
  }
  return (
    <Grid size={currentElementState.columns}>
      <FormGenComponent
        control={control}
        setValue={setValue}
        schema={schema}
        parsedJsonSchema={parsedJsonSchema}
        uiSchemaIndex={uiSchemaIndex}
        uiSchemaElement={currentElementState}
        context={context}
      />
    </Grid>
  );
};
